

import React  from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { BOTTOMMENUDATA, TRANSLATION } from '../constants/state'
import { useWPMenuTree } from '../Accessibility/DisclosureNavigationMenu/useWPMenuTree';
import DisclosureNavigationMenu from '../Accessibility/DisclosureNavigationMenu/DisclosureNavigationMenu';




const mapStateToProps = (state, ownProps) => ({
    menuData: getData(state, BOTTOMMENUDATA),
    translation: getData(state, TRANSLATION), 
})


const SiteFooterAccess = ({
    menuData,
    translation
}) => {
    const sanMenuData =  {
        order: menuData.order,
        items: {}
    } 
    
    menuData.order.map(id => {
        const item = menuData.items[id]

        sanMenuData.items[id] = {
            ID: item.ID,
            url: item.permalink,
            title: item.post_title,
            target: '',
            is_active: false,
            menu_item_parent: "0"
        }
    })


    const [menuTree, changeMenuTree] = useWPMenuTree(sanMenuData)

    return (
        <footer className="theme-access access-site-footer">
            <div className="grid-site-wrapper">
                <DisclosureNavigationMenu
                    accessName='Footer Navigation'
                    menuTree={menuTree}
                    translation={translation}
                    onChangeMenuTree={changeMenuTree}
                />
            </div>
        </footer>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(SiteFooterAccess)